<template>
    <div class="phhonor ph-news">
        <el-backtop ></el-backtop>
        <hpheader></hpheader>

        <div class="position-bar-container">
            <position-bar :positionNav="positionNav">
            </position-bar>
        </div>

        <div class="slider">
            <el-carousel :interval="5000" arrow="never" :height="imgHeight" ref="slideCarousel">
                <el-carousel-item v-for="(item,index) in banners" :key="index" >
                    <img :src="item.mobile_image" alt="" ref="imgHeight" mode="widthFix" @load="imgLoad" @click="navnewdetail(item.id)">
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="phanew-cont">
            <div class="phnewcontss">
                <div class="phnew-item" v-for="(item,index) in news.list" @click="navnewdetail(item.id)">
                    <div class="phnewitem-img">
                        <img :src="item.thumb" />
                    </div>
                    <div class="phnew-item-text">
                        <div class="phnew-name">
                            {{item.en_title}}
                        </div>
                        <div class="phnew-time">
                            {{ $utils.formatDate(item.createtime) }}
                        </div>
                    </div>
                    <!--                    <div class="phnew-title">{{item.mark}}</div>-->
                </div>
            </div>
        </div>

        <div ref="bottom" style="width: 100%;height: .5rem;"></div>
        <hpfooter></hpfooter>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from "../../storage/storage";
    import positionBar from '../../components/ph-position-bar.vue'

    export default{
        data(){
            return{
                info:{},
                newacti:2,
                newsize:5,
                morenew:true,
                newnav:1,
                pcnewtyp:[],
                newlists:[],
                imgHeight: '',
                banners: [],
                positionNav:[
                    {
                        title:'Home',
                        path:'/phhome',
                    },
                    {
                        title:'News',
                        path:'',
                    },
                ],
                page:{
                    current_page:1,
                    last_page:1,
                },
                loading: false,
                news:{
                    list:[]
                },
                isLoad:false
            }
        },
        created() {
            window.scrollTo(0,0);
            this.ress()
            this.pcnewtype()
            // this.pcnewlist();
            this.pageParam()
            if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'pc-news'})
                return
            }
        },
        mounted(){
            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            this.slideBanner()
            this.initData()
        },
        components:{
            hpfooter,
            hpheader,
            positionBar
        },
        methods:{
            initData(){
                const _this = this
                _this.loading =true
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                }
                Promise.all([new Promise((resolve, reject) => {
                    this.$api.get_news_center_slider(data).then(res => {
                        resolve(res)
                    })
                }),new Promise((resolve, reject) => {
                    _this.$api.get_news_center_list(data).then(res => {
                        _this.page.current_page = res.data.current_page
                        _this.page.last_page = res.data.last_page
                        _this.page.per_page = res.data.per_page
                        _this.checkoutDataEnd()
                        resolve(res)
                    })
                })
                ]).then(res => {
                    _this.banners = res[0].data
                    _this.news.list = res[1].data.data
                    this.loading =false
                    window.onresize = () => {
                        _this.imgLoad()
                    }
                })
            },
            newsCenterList(){
                const _this = this

                _this.page.current_page ++
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:_this.page.current_page,
                }

                _this.$api.get_news_center_list(data).then(res => {
                    _this.page.current_page = res.data.current_page
                    _this.page.last_page = res.data.last_page
                    _this.page.per_page = res.data.per_page
                    _this.news.list = _this.news.list.concat(res.data.data)
                    _this.checkoutDataEnd()
                })
            },
            handleScroll(){
                if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                    this.load()
                }
            },
            load(){
                if(this.loading){
                    return
                }
                this.loading = true
                this.newsCenterList()
            },
            checkoutDataEnd(){
                this.loading = this.page.current_page >= this.page.last_page ? true : false
            },
            slideBanner() {
                var box = document.querySelector('.el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                var resetPoint = function () {
                    startPoint = 0;
                    stopPoint = 0;
                }
                box.addEventListener("touchstart", function (e) {
                    startPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchmove", function (e) {
                    stopPoint = e.changedTouches[0].pageX;
                });
                let that = this
                box.addEventListener("touchend", function (e) {
                    if (stopPoint == 0 || startPoint - stopPoint == 0) {
                        resetPoint();
                        return;
                    }
                    if (startPoint - stopPoint > 0) {
                        resetPoint();
                        that.$refs.slideCarousel.next();
                        return;
                    }
                    if (startPoint - stopPoint < 0) {
                        resetPoint();
                        that.$refs.slideCarousel.prev();
                        return;
                    }
                });
            },
            imgLoad() {
                // 获取图片高度
                this.$nextTick(() => {
                    this.imgHeight = this.$refs.imgHeight['0'].height + 'px'
                })
            },
            newmore(){
                this.newsize+=5
                this.pcnewlist()
            },
            navnewdetail(id){
                let typeid=this.newnav
                this.$router.push({path: '/ph-news-detail',query:{id,typeid}});
            },
            newnavcli(e){
                this.newacti=e
                this.newnav = e
                this.pcnewlist()
            },
            pcnewtype(){
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'h5',
                }
                this.$api.get_new_type(data).then((res) => {
                    this.pcnewtyp=res.data
                    if(res.data.length>0){
                        this.newnavcli(res.data[0].id)
                    }
                });
            },
            pcnewlist(){
                let data={
                    type_id:this.newnav,
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'h5',
                    page:'1',
                    pageSize:this.newsize,
                }
                this.$api.get_new_list(data).then((res) => {
                    this.newlists=res.data
                    if(this.newsize>this.newlists.length){
                        this.morenew=false
                    }
                });
            },
            pageParam(){
                let lang =  session.get("lang");
                if (lang === "cn"){
                    this.leftuscreated =  [
                        {'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
                        {'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
                    ]
                    this.rightuscreated =  [
                        {'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
                        {'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的，梦想'},

                    ]
                    this.year = "年"
                    this.info = {
                        'about': "关于啄木鸟",
                        'around': "公司环境",
                        'honor': '公司荣誉',
                        'news' : '新闻中心',
                        'course' : '公司历程',
                        'more' : "显示更多",
                        'special': '专题',
                    }
                }else{
                    this.created = "Woodpecker creation"
                    this.leftuscreated =  [
                        {'ustitle':'Our core values','usmintitle':'Earnest, honest and grateful'},
                        {'ustitle':'Our style','usmintitle':'Think there is a way, do it first, fast, accurate and obscene'},
                    ]
                    this.rightuscreated =  [
                        {'ustitle':'Our guidelines','usmintitle':'Loyal, serious, professional, innovative, pursuing excellence, taking customers as the core and changing everything for customers'},
                        {'ustitle':'Our vision','usmintitle':'Create a world-class enterprise, be a pioneer in China, win the respect and trust of global customers, and realize the dream of woodpecker'},
                    ]
                    this.year = "year"
                    this.info = {
                        'about': "About woodpecker",
                        'around': "Company environment",
                        'honor': 'Company honor',
                        'news' : 'News Center',
                        'course' : 'Company history',
                        'more' : "More",
                        'special': 'Special',
                    }

                }
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },

        }
    }
</script>

<style>
    body{
        margin: 0;
        padding: 0;
    }

    .phhonor{
        background: #FFF;
        padding-top: 0.88rem;
    }
    .phhonor-hea{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 7.5rem;
        height: 0.88rem;
        background: #FFFFFF;
    }
    .phhonorhea-left{
        margin-left: 0.3rem;
        width: 0.97rem;
        height: 0.5rem;
    }
    .phhonorhea-left img{
        width: 100%;
        height: 100%;
    }
    .phhonorhea-right{
        margin-right: 0.3rem;
        width: 0.38rem;
        height: 0.38rem;
    }
    .phhonorhea-right img{
        width: 100%;
        height: 100%;
    }
    .phvir-hea{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.36rem;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
    }
    .phnewsnav-con{
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;
        margin-left: 0.3rem;
    }
    .phnewsnavcoont-item{
        min-width: 1.2rem;
        text-align: center;
        margin-right: 0.32rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-bottom: 0.4rem;
    }
    .phnewitem-img{
        border-radius: 0.06rem;
    }
    .phnewitem-img img{
        display: block;
        width: 100%;
    }
    .phnewcontss{
        margin-bottom: 0.6rem;
        margin-top: .3rem;
        padding: 0 .3rem;
    }
    .phnew-item-text {
        padding: .4rem;
    }
    .phnew-time{
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-top: 0.2rem;
    }
    .neewhealc{
        color: #D03E3D;
    }
    .phnewtime-left{
        width: 1rem;
        height: 0.4rem;
        background: #D03E3D;
        border-radius: 0.05rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 0.01rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.2rem;
    }
    .phnew-name{
        font-size: 0.32rem;
        font-weight: bold;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
    }
    .phnew-title{
        font-size: 0.24rem;
        font-weight: 500;
        color: #999999;
        letter-spacing: 0.01rem;
        margin-top: 0.17rem;
    }
    .phnew-item{
        margin-bottom: 0.5rem;
        box-shadow: 0 .1rem .2rem 0 rgba(0,0,0,.1);
        border-radius: 20px;
        overflow: hidden;
    }
    .phnews-nav{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.4rem;
    }
    .phnew-more{
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .phnew-more img{
        width: 0.3rem;
        height: 0.3rem;
    }
    .phnewcont{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.7rem;
        height: 0.5rem;
        border-radius: 0.06rem;
        border: 0.01rem solid #999;
        font-size: 0.28rem;
        color: #999;
        margin-bottom: 0.3rem;
    }

    .ph-news {

    }
    .ph-news .slider .el-carousel img{
        width: 100%;
    }

    .ph-news .slider .el-carousel__indicators--horizontal {
        display: block!important;
    }
    .ph-news .slider .el-carousel__button {
        width: 60px;
        height: 1px;
    }
</style>
